import { render, staticRenderFns } from "./msgIndex.vue?vue&type=template&id=ff623b9c&scoped=true"
import script from "./msgIndex.vue?vue&type=script&lang=js"
export * from "./msgIndex.vue?vue&type=script&lang=js"
import style0 from "./msgIndex.vue?vue&type=style&index=0&id=ff623b9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff623b9c",
  null
  
)

export default component.exports